import { HTMLAttributes } from "react";
import { cn } from "@facade/lib/utils";

export const ResponsiveContent = ({
  reduced,
  className,
  children,
}: HTMLAttributes<HTMLDivElement> & {
  reduced?: boolean;
}) => {
  return (
    <div
      className={cn(
        "flex-1 w-full max-w-none",
        reduced ? "min-[1920px]:max-w-380" : "min-[1920px]:max-w-480",
        className,
      )}
    >
      {children}
    </div>
  );
};
